import { Box } from '@chakra-ui/react'

import useStore from '../../store/useStore'
import ImpersonationBanner from '../ImpersonationBanner'
import Toolbar from '../Toolbar'

const Header = () => {
  const user = useStore((state) => state.user)

  return (
    <Box as="header">
      {user && <Toolbar />}
      <ImpersonationBanner />
    </Box>
  )
}

export default Header
